// Component: Icon.jsx
// Purpose: DS icon — renders a curated Lucide-style inline SVG by name at a
//   consistent size + 1.8 stroke, inheriting currentColor (so `text-*` colors
//   it, and it theme-swaps for free). Per design-system/preview/icons.html.
//   Usage: <Icon name="search" size={16} />  ·  <Icon name="gain" className="text-profit" />

import React from "react";
import { cx } from "./cx";
import { ICON_PATHS } from "./icons";

export function Icon({ name, size = 16, strokeWidth = 1.8, title, className, ...props }) {
  const shapes = ICON_PATHS[name];
  if (!shapes) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[ds/Icon] unknown icon name: "${name}"`);
    }
    return null;
  }
  return (
    <svg
      className={cx("ds-icon", className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {shapes}
    </svg>
  );
}

export default Icon;
